import { Users, Target, Eye, Award, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function About() {
  const team = [
    {
      name: "Ibrahim Dbouk",
      role: "CEO & Founder",
      image: "https://111images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=800",
      description: "With over 15 years of experience in IT consulting"
    },
    {
      name: "  ",
      role: "Technical Director",
      image: "https://111images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=800",
      description: "Expert in digital transformation and cloud solutions"
    },
    {
      name: "   ",
      role: "Solutions Architect",
      image: "https://111images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&q=80&w=800",
      description: "Specializing in enterprise architecture and IT strategy"
    }
  ];

  const partners = [
    {
      name: "Microsoft",
      image: "https://images.unsplash.com/photo-1633419461186-7d40a38105ec?auto=format&fit=crop&q=80&w=800",
      description: "Cloud Solutions Partner"
    },
    {
      name: "Amazon Web Services",
      image: "https://images.unsplash.com/photo-1549605659-32d82da3a059?auto=format&fit=crop&q=80&w=800",
      description: "Infrastructure Partner"
    },
    {
      name: "Oracle",
      image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&q=80&w=800",
      description: "Database Solutions Partner"
    },
    {
      name: "Cisco",
      image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&q=80&w=800",
      description: "Network Solutions Partner"
    }
  ];

  return (
    <div className="py-16">
      {/* Hero Section */}
      <section className="relative h-[500px] mb-16">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1504384764586-bb4cdc1707b0?auto=format&fit=crop&q=80&w=1920')"
          }}
        >
          <div className="absolute inset-0 bg-blue-900/80" />
        </div>
        <div className="relative h-full flex items-center">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-white">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">About ND Tech Solutions</h1>
            <p className="text-xl max-w-3xl">
              We are a leading IT services and consultancy company dedicated to helping businesses 
              leverage technology for growth and innovation.
            </p>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-16">
        <div className="grid md:grid-cols-2 gap-12">
          <div className="relative group overflow-hidden rounded-lg">
            <img
              src="https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80&w=1920"
              alt="Our Mission"
              className="w-full h-96 object-cover transform group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-blue-900/90 via-blue-900/50 to-transparent p-8 flex flex-col justify-end">
              <div className="text-blue-400 mb-4">
                <Target className="h-12 w-12" />
              </div>
              <h2 className="text-2xl font-bold mb-4 text-white">Our Mission</h2>
              <p className="text-white/90">
                To empower businesses through innovative technology solutions, enabling their digital 
                transformation and sustainable growth in an ever-evolving digital landscape.
              </p>
            </div>
          </div>
          
          <div className="relative group overflow-hidden rounded-lg">
            <img
              src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&q=80&w=1920"
              alt="Our Vision"
              className="w-full h-96 object-cover transform group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-blue-900/90 via-blue-900/50 to-transparent p-8 flex flex-col justify-end">
              <div className="text-blue-400 mb-4">
                <Eye className="h-12 w-12" />
              </div>
              <h2 className="text-2xl font-bold mb-4 text-white">Our Vision</h2>
              <p className="text-white/90">
                To be the leading technology partner for businesses in Lebanon and beyond, 
                known for excellence, innovation, and transformative IT solutions.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="bg-gray-50 py-16 mb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="text-blue-600 mb-4 flex justify-center">
              <Users className="h-12 w-12" />
            </div>
            <h2 className="text-3xl font-bold mb-4">Our Team</h2>
            <p className="text-xl text-gray-600">
              Led by experienced professionals dedicated to your success
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {team.map((member, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden group">
                <div className="relative h-64">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                    <h3 className="text-xl font-bold">{member.name}</h3>
                    <p className="text-blue-400">{member.role}</p>
                  </div>
                </div>
                <div className="p-6">
                  <p className="text-gray-600">{member.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Partners Section */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="text-blue-600 mb-4 flex justify-center">
            <Award className="h-12 w-12" />
          </div>
          <h2 className="text-3xl font-bold mb-4">Our Partners</h2>
          <p className="text-xl text-gray-600">
            Working with leading technology providers to deliver the best solutions
          </p>
        </div>
        <div className="grid md:grid-cols-4 gap-8">
          {partners.map((partner, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden group">
              <div className="relative h-48">
                <img
                  src={partner.image}
                  alt={partner.name}
                  className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
                  <h3 className="font-bold">{partner.name}</h3>
                  <p className="text-sm text-blue-400">{partner.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-blue-600 mt-16 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h2 className="text-3xl font-bold mb-4">Ready to Work Together?</h2>
          <p className="text-xl mb-8">Let's discuss how we can help transform your business</p>
          <Link
            to="/contact"
            className="inline-flex items-center bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors"
          >
            Get in Touch
            <ArrowRight className="ml-2 h-5 w-5" />
          </Link>
        </div>
      </section>
    </div>
  );
}